import AsdXMLHttpRequest from './xmlhttprequest.js';

export default class Request {
    constructor(reqListener, caller) {
        this.xhr = new AsdXMLHttpRequest(caller);
        this.xhr.addEventListener( 'load', reqListener );
    }

    https_request(method, url, data) {
        switch ( method ) {
            case 'GET':
                if (data.length > 0) {
                    if ( url.indexOf( '?' ) > -1 ) {
                        url = url + '&' + this.serialize( data );
                    } else {
                        url = url + '?' + this.serialize( data );
                    }
                }

                this.xhr.open( method, url, true );
                this.xhr.send();
                break;

            case 'POST':
                this.xhr.open( method, url, true);
                // We have to distinguish various case:
                // 1) Form data request
                if ( data instanceof  Array ) {
                    this.xhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
                    data = this.serialize( data );
                }
                // 2) Custom data POST request
                if ( typeof data === 'object' ) {
                    data = JSON.stringify( data );
                    this.xhr.setRequestHeader("Content-Type", "application/json");
                }
                // Then we finally send the data whatever' form they are
                this.xhr.send( data);
                break;
            /* TODO put request
            case 'PUT':
              data = this.serialize( data );
              break;
            */
            default:
                console.log( 'Error, method not found: ' + method );
        }
    }

    get( url, data ) {
        this.https_request( 'GET', url, data );
    }

    post( url, data ) {
        this.https_request( 'POST', url, data );
    }

    /* https://stackoverflow.com/questions/1714786/query-string-encoding-of-a-javascript-object */
    serialize(obj, prefix) {
        var str = [], p;
        for(p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                    this.serialize(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }
}